import {
  booleanAttribute,
  Component,
  computed,
  HostBinding,
  input,
  model,
} from '@angular/core';
import { SegmentTabComponent } from './segment-tab/segment-tab.component';
import { ScrollGuideDirective } from '@malirang/front-share';

export type SegmentTabOption = {
  label: string;
  value: string;
  count?: number;
  icon?: string;
};

@Component({
  selector: 'app-segment-tabs',
  templateUrl: './segment-tabs.component.html',
  imports: [SegmentTabComponent, ScrollGuideDirective],
})
export class SegmentTabsComponent {
  @HostBinding('class') get hostClass() {
    if (this.expand()) {
      return 'w-full';
    }

    return '';
  }

  expand = input<boolean, string>(false, {
    alias: 'expand',
    transform: booleanAttribute,
  });
  value = model<any>('');
  $options = input<string[] | SegmentTabOption[]>([], { alias: 'options' });

  options = computed<SegmentTabOption[]>(() => {
    if (this.$options().length === 0) return [];

    return this.$options().map((option) => {
      if (typeof option === 'string') {
        return {
          label: option,
          value: option,
        };
      }

      return option;
    });
  });

  ngOnInit(): void {
    if (!this.value()) {
      this.value.set(this.options()[0]?.value);
    }
  }
}
